export enum UserRole {
  Staff = 'Staff',
}

export type UserModel = {
  account?: string;
  allowPersonalization?: boolean;
  email?: string;
  featuresBitField?: number;
  isAuthenticated?: boolean;
  name?: string;
  packageLevel?: string;
  roles?: UserRole[];
  salesForceAccountId?: string;
  salesforceId?: string;
  userId?: string;
  isIpBasedIdentity?: boolean;
  amsUserId?: number;
};
